import { render, staticRenderFns } from "./historyImage.vue?vue&type=template&id=89e77f28&"
import script from "./historyImage.vue?vue&type=script&lang=js&"
export * from "./historyImage.vue?vue&type=script&lang=js&"
import style0 from "./historyImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports